import { defaultHttpClient } from '../../httpClient';
import type { GetMidRelatedRecommendGoodsResponse } from './types';

export const getMidRelatedAdGoods = async (goodsSno: number) => {
  return defaultHttpClient
    .request<GetMidRelatedRecommendGoodsResponse>({
      method: 'GET',
      url: `/api/v2/goods/${goodsSno}/mid_related_recommend_ad_goods/`,
    })
    .then(result => result.data);
};
